import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "@/components/common/CommonTitle";
import Image, { StaticImageData } from "next/image";

const SummarySection = ({
  title,
  subtitle,
  featureList,
}: {
  title: string;
  subtitle: string;
  featureList: {
    title: string;
    subtitle: string;
    featuredImg: StaticImageData;
  }[];
}) => {
  return (
    <section className="pt-[40px] xl:pt-[60px]">
      <div className="container">
        <div className="mx-auto max-w-[1100px] space-y-4 pb-5 text-center xl:space-y-8 xl:px-20 xl:pb-16">
          <CommonTitle
            fontWeightClass="font-semibold"
            fontSizeClass="text-[28px] xl:text-[32px]"
          >
            {title}
          </CommonTitle>
          <CommonSubtitle
          >
            {subtitle}
          </CommonSubtitle>
        </div>
        <div className="mt-8 grid grid-cols-1 items-start gap-6 lg:grid-cols-2 lg:gap-10 xl:mt-12 xl:grid-cols-3">
          {featureList.map((item, index) => (
            <div
              key={index}
              className="flex h-full flex-col space-y-1 rounded-[8px] bg-gradient-to-t from-[#F4F1FF] to-white"
            >
              <div className="relative w-full h-[300px]">
                <Image
                  src={item.featuredImg}
                  alt="Kroolo flexible AI tools features"
                  className="rounded-[8px] object-contain h-full w-full p-2"
                />
              </div>
              <div className="flex flex-grow flex-col gap-2 p-4">
                <h3 className="text-[18px] lg:text-[20px] font-semibold text-[#202020]">
                  {item.title}
                </h3>
                <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SummarySection;
